import { Getter, Setter, createLens } from '@dhmk/zustand-lens';
import { Draft } from 'immer';
import type {
  GraphId,
  GraphValidation,
} from '../../components/graph-editor/types/graph';
import type { GraphsSlice } from '.';

export interface IValidation {
  get: () => GraphValidation;
  getGraphId: () => GraphId;
  set: (validation: GraphValidation) => void;
}

export const createValidationAPI = (
  _set: Setter<Draft<GraphsSlice>>,
  _get: Getter<Draft<GraphsSlice>>,
  graphId: GraphId
): IValidation => {
  const [set, get] = createLens(_set, _get, ['validations', graphId]) as [
    Setter<Draft<GraphValidation>>,
    Getter<Draft<GraphValidation>>
  ];

  return {
    get: () => get(),
    getGraphId: () => graphId,
    set: (validation) => {
      set(() => validation);
    },
  };
};
